export const SIGN_IN = 'SIGN_IN'
export const SIGN_UP = 'SIGN_UP'
export const SIGN_OUT = 'SIGN_OUT'
export const TFA_LOGIN = 'TFA_LOGIN'
export const EXTEND_SESSION = 'EXTEND_SESSION'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const TFA_ENROLLMENTS = 'TFA_ENROLLMENTS'
